import { combineReducers,createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import {currentRouteReducer,authInfoReducer,createdCategoryReducer,
  updatedCategoryReducer,disableRestoreCategoryReducer,createBrandReducer,updateBrandReducer,
  createdFloorReducer, updatedFloorReducer, disableRestoreFloorReducer, createdRackReducer, updatedRackReducer, disableRestoreRackReducer,
  brandDisableRestoreReducer,createdColorReducer,updatedColorReducer,colorDisableRestoreReducer,
  createdUnitReducer,updatedUnitReducer,unitDisableRestoreReducer,
  createdBranchReducer,updatedBranchReducer,branchDisableRestoreReducer,
  createdWarehouseReducer,
  updatedWarehouseReducer,
  warehouseDisableRestoreReducer,
  createdAreaReducer,updatedAreaReducer,areaDisableRestoreReducer,
  createdMaterialReducer,updatedMaterialReducer,materialCodeReducer,disableRestoreMaterialReducer,
  createdProdNameReducer,updatedProdNameReducer,prodNameDisableRestoreReducer ,
  createdDeliveryNameReducer,updatedDeliveryNameReducer,deliveryNameDisableRestoreReducer ,
  createdDeliveryReducer,updatedDeliveryReducer,deliveryDisableRestoreReducer ,
  createdTransportNameReducer,updatedTransportNameReducer,transportNameDisableRestoreReducer ,
  createdMaterialNameReducer,updatedMaterialNameReducer,materialDisableRestoreReducer,
  createdProductSetReducer,updatedProductReducer,productCodeReducer,productDisableRestoreReducer,customerCodeReducer,
  createdCustomerReducer,updatedCustomerReducer,customerDisableRestoreReducer,
  createdSupplierReducer,updatedSupplierReducer,supplierDisableRestoreReducer,
  createdDesignationReducer,updatedDesignationReducer,designationDisableRestoreReducer,
  createdDepartmentReducer,updatedDepartmentReducer,departmentDisableRestoreReducer,
  createdMonthReducer,updatedMonthReducer,monthDisableRestoreReducer,
  createdEmployeeReducer,updatedEmployeeReducer,employeeDisableRestoreReducer,employeeCodeReducer,
  createdTranAccReducer,updatedTranAccReducer,tranAccDisableRestoreReducer,tranAccCodeReducer,
  createdBankAccReducer,updatedBankAccReducer,bankAccDisableRestoreReducer,bankAccCodeReducer,
  createdCashTranReducer,updatedCashTranReducer,cashTranDisableRestoreReducer,cashTranCodeReducer,
  createdBankTranReducer,updatedBankTranReducer,bankTranDisableRestoreReducer,bankTranCodeReducer,
  createdCustomerPayReducer,updatedCustomerPayReducer,customerPayDisableRestoreReducer,
  createdSupplierPayReducer,updatedSupplierPayReducer,supplierPayDisableRestoreReducer,
  saleReturnCartReducer,returnChangeReducer,purchaseReturnChangeReducer,
  createdEmailCcNameReducer,updatedEmailCcNameReducer, emailCcNameDisableRestoreReducer,
} from './common_reducers';

const reducers = combineReducers({
    currentRouteReducer,
    authInfoReducer,
    createdCategoryReducer,
    updatedCategoryReducer,
    disableRestoreCategoryReducer,
    createdFloorReducer,
    updatedFloorReducer,
    disableRestoreFloorReducer,
    createdRackReducer, 
    updatedRackReducer, 
    disableRestoreRackReducer,
    createBrandReducer,
    updateBrandReducer,
    brandDisableRestoreReducer,
    createdColorReducer,
    updatedColorReducer,
    colorDisableRestoreReducer,
    createdUnitReducer,
    updatedUnitReducer,
    unitDisableRestoreReducer,
    createdBranchReducer,
    updatedBranchReducer,
    branchDisableRestoreReducer,
    createdWarehouseReducer,
    updatedWarehouseReducer,
    warehouseDisableRestoreReducer,
    createdAreaReducer,updatedAreaReducer,areaDisableRestoreReducer,
    createdProdNameReducer,updatedProdNameReducer,prodNameDisableRestoreReducer, 
    createdDeliveryNameReducer,updatedDeliveryNameReducer,deliveryNameDisableRestoreReducer ,
    createdDeliveryReducer,updatedDeliveryReducer,deliveryDisableRestoreReducer ,
    createdTransportNameReducer,updatedTransportNameReducer,transportNameDisableRestoreReducer, 
    createdMaterialNameReducer,updatedMaterialNameReducer,materialDisableRestoreReducer,
    createdProductSetReducer,updatedProductReducer,productCodeReducer,productDisableRestoreReducer,
    customerCodeReducer,
    createdCustomerReducer,updatedCustomerReducer,customerDisableRestoreReducer,
    createdSupplierReducer,updatedSupplierReducer,supplierDisableRestoreReducer,
    createdDesignationReducer,updatedDesignationReducer,designationDisableRestoreReducer,
    createdDepartmentReducer,updatedDepartmentReducer,departmentDisableRestoreReducer,
    createdMonthReducer,updatedMonthReducer,monthDisableRestoreReducer,
    createdEmployeeReducer,updatedEmployeeReducer,employeeDisableRestoreReducer,employeeCodeReducer,
    createdTranAccReducer,updatedTranAccReducer,tranAccDisableRestoreReducer,tranAccCodeReducer,
    createdBankAccReducer,updatedBankAccReducer,bankAccDisableRestoreReducer,bankAccCodeReducer,
    createdCashTranReducer,updatedCashTranReducer,cashTranDisableRestoreReducer,cashTranCodeReducer,
    createdBankTranReducer,updatedBankTranReducer,bankTranDisableRestoreReducer,bankTranCodeReducer,
    createdCustomerPayReducer,updatedCustomerPayReducer,customerPayDisableRestoreReducer,
    createdSupplierPayReducer,updatedSupplierPayReducer,supplierPayDisableRestoreReducer,
    saleReturnCartReducer,returnChangeReducer,purchaseReturnChangeReducer,
    createdEmailCcNameReducer,updatedEmailCcNameReducer, emailCcNameDisableRestoreReducer,
    createdMaterialReducer,updatedMaterialReducer,materialCodeReducer,disableRestoreMaterialReducer,
});

const persistConfig = {
  key: 'root',
  storage,
  blacklist:['currentRouteReducer','createdCategoryReducer','updatedCategoryReducer',
  'createdFloorReducer', 'updatedFloorReducer', 'disableRestoreFloorReducer', 'createdRackReducer', 'updatedRackReducer', 'disableRestoreRackReducer',
  'disableRestoreCategoryReducer','createBrandReducer','updateBrandReducer','brandDisableRestoreReducer','createdColorReducer',
  'updatedColorReducer','colorDisableRestoreReducer','createdUnitReducer','updatedUnitReducer','unitDisableRestoreReducer',
  'createdBranchReducer','updatedBranchReducer','branchDisableRestoreReducer',
  'createdWarehouseReducer','updatedWarehouseReducer','warehouseDisableRestoreReducer',
  'createdAreaReducer','updatedAreaReducer','areaDisableRestoreReducer',
  'createdProdNameReducer','updatedProdNameReducer','prodNameDisableRestoreReducer',
  'createdDeliveryNameReducer','updatedDeliveryNameReducer','deliveryNameDisableRestoreReducer' ,
  'createdDeliveryReducer','updatedDeliveryReducer','deliveryDisableRestoreReducer' ,
  'createdTransportNameReducer','updatedTransportNameReducer','transportNameDisableRestoreReducer',
  'createdProductSetReducer','updatedProductReducer','productCodeReducer','productDisableRestoreReducer',
  'customerCodeReducer',
  'createdCustomerReducer','updatedCustomerReducer','customerDisableRestoreReducer',
  'createdSupplierReducer','updatedSupplierReducer','supplierDisableRestoreReducer',
  'createdDesignationReducer','updatedDesignationReducer','designationDisableRestoreReducer',
  'createdDepartmentReducer','updatedDepartmentReducer','departmentDisableRestoreReducer',
  'createdMonthReducer','updatedMonthReducer','monthDisableRestoreReducer',
  'createdEmployeeReducer','updatedEmployeeReducer','employeeDisableRestoreReducer','employeeCodeReducer',
  'createdTranAccReducer','updatedTranAccReducer','tranAccDisableRestoreReducer','tranAccCodeReducer',
  'updatedBankAccReducer','updatedBankAccReducer','bankAccDisableRestoreReducer','bankAccCodeReducer',
  'createdCashTranReducer','updatedCashTranReducer','cashTranDisableRestoreReducer','cashTranCodeReducer',
  'createdBankTranReducer','updatedBankTranReducer','bankTranDisableRestoreReducer','bankTranCodeReducer',
  'createdCustomerPayReducer','updatedCustomerPayReducer','customerPayDisableRestoreReducer',
  'createdSupplierPayReducer','updatedSupplierPayReducer','supplierPayDisableRestoreReducer',
  'saleReturnCartReducer','return_rate_change_set','returnChangeReducer','purchaseReturnChangeReducer',
  'createdMaterialReducer','updatedMaterialReducer','materialCodeReducer','disableRestoreMaterialReducer',
  'createdEmailCcNameReducer','updatedEmailCcNameReducer', 'emailCcNameDisableRestoreReducer',

]
}
 

const persistedReducer = persistReducer(persistConfig, reducers)
const store = createStore(persistedReducer)
const persistor = persistStore(store)
export  {store,persistor}